/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Hint_LinkedInputs */

const cs_pm_hint_linked = /** @type {(inputs: Pm_Hint_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Už propojeno`)
};

const en_pm_hint_linked = /** @type {(inputs: Pm_Hint_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already linked`)
};

/**
* | output |
* | --- |
* | "Already linked" |
*
* @param {Pm_Hint_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_hint_linked = /** @type {((inputs?: Pm_Hint_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Hint_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_hint_linked(inputs)
	return cs_pm_hint_linked(inputs)
});